"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleTeaserModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const services_1 = require("../../services");
const ui_1 = require("../_abstract/ui");
const _contracts_1 = require("../_contracts");
const ui_2 = require("../_components/ui");
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const _filters_1 = require("../_filters");
const ArticleHeaderVideo_1 = __importDefault(require("../_components/ArticleHeader/ArticleHeaderVideo/ArticleHeaderVideo"));
const bootstrap_1 = require("../../dsl/bootstrap");
const Gallery_1 = require("../_components/Gallery");
const vue_no_ssr_1 = __importDefault(require("vue-no-ssr"));
const vue_easy_lightbox_1 = __importDefault(require("vue-easy-lightbox"));
const AdBanner_ui_1 = require("../AdBanner/AdBanner.ui");
/**
 * Component capable of rendering the `ArticleTeaser's` contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
let ArticleTeaserModuleUi = class ArticleTeaserModuleUi extends ui_1.AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.AppTheme = _contracts_1.AppTheme;
        this.image = null;
        this.author = null;
        /**
         * Social channels available in the article.
         */
        this.enabledServices = ['facebook', 'twitter', 'linkedin', 'instagram'];
        /**
         * Article's thumbnail.
         */
        this.thumbnail = null;
        this.maxWidth = undefined;
        /**
         * Article author's avatar.
         */
        this.authorAvatar = null;
        this.gallery = null;
        this.headerData = {};
        /**
         * Determines whether image is displayed in full screen mode
         */
        this.isFullScreenPreviewOpen = false;
        /**
         * Article author's full name.
         */
        this.authorName = '';
        this.forceHideAd = false;
        this.video = {
            file: undefined,
            playOnTile: false,
            url: '',
            onNetworkUrl: ''
        };
        this.emptyAds = () => {
            console.log('Empty cover Ad');
        };
    }
    get getHeaderData() {
        return this.headerData;
    }
    get resAuthor() {
        return this.author;
    }
    watchEvents() {
        if (!this.eventBus) {
            return;
        }
        this.eventBus.handle('ui:video-player.play', this.hideAds);
    }
    hideAds() {
        this.forceHideAd = true;
    }
    get canHidePublicationDate() {
        if (this.parent.getOption('hidePublicationDate') && typeof this.parent.getOption('hidePublicationDate') === 'boolean') {
            return true;
        }
        return false;
    }
    async fetchImage(cover) {
        let image = null;
        try {
            image = typeof cover === 'object' && cover !== null &&
                typeof cover.image === 'object' && cover.image !== null && !!cover.image.value
                ? await this.relatedService.resolve(cover.image) : null;
        }
        catch (e) {
            image = null;
        }
        // Overwriting image data by CoverAddon data
        if (image && typeof cover === 'object' && cover !== null) {
            const shouldOverride = typeof cover.override === 'undefined' ? false : cover.override;
            if (shouldOverride && typeof cover.caption === 'string') {
                image.caption = cover.caption;
            }
            if (shouldOverride && typeof cover.alt === 'string') {
                image.alt = cover.alt;
            }
            if (shouldOverride && typeof cover.imageAuthor === 'string') {
                image.author = cover.imageAuthor;
            }
        }
        this.image = image;
        this.thumbnail = _filters_1.prepareImage(this.image, _contracts_1.ImageRatio.Standard169, this.maxWidth, this.isLazy);
    }
    async fetchAuthor(author) {
        try {
            this.author = await this.relatedService.resolve(author);
            if (this.author.avatar) {
                this.authorAvatar = _filters_1.prepareImage(this.author.avatar, _contracts_1.ImageRatio.Square, 28, this.isLazy);
            }
            this.authorName = `${this.author.firstName} ${this.author.lastName}`;
        }
        catch (e) {
            console.warn(e);
        }
    }
    async fetchVideo(cover) {
        let video = null;
        try {
            if (typeof cover !== 'object' || cover === null) {
                video = null;
            }
            else {
                const videoFile = typeof cover.video === 'object' && cover.video !== null &&
                    typeof cover.video.file === 'object' && !!cover.video.file.value
                    ? await this.relatedService.resolve(cover.video.file) : null;
                video = {
                    ...cover.video
                    // file: videoFile
                };
            }
        }
        catch (e) {
            video = null;
        }
        this.video = video;
    }
    async fetchGallery(cover) {
        let gallery = null;
        try {
            if (typeof cover === 'object' &&
                cover !== null &&
                typeof cover.gallery === 'object' &&
                cover.gallery !== null) {
                const imageCollection = await this.relatedService.resolve(cover.gallery);
                gallery = (Array.isArray(imageCollection) ? imageCollection : [imageCollection]);
            }
            else {
                gallery = null;
            }
        }
        catch (e) {
            gallery = null;
        }
        this.gallery = gallery;
    }
    /**
     * Checking that content has gallery
     */
    get hasGallery() {
        return !!this.gallery;
    }
    /**
     * Determines whether the article has its corresponding video.
     */
    get hasVideo() {
        if (!this.video) {
            return false;
        }
        const checkUrl = (typeof this.video.url === 'string' && this.video.url.length > 0);
        const checkFile = (this.video.file && typeof this.video.file === 'object' && (!!this.video.file.m3u8 || !!this.video.file.url)) === true;
        const checkOn = (typeof this.video.onNetworkUrl === 'string' && this.video.onNetworkUrl.length > 0);
        return checkUrl || checkOn || checkFile;
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        try {
            const parent = this.parent;
            const cover = this.parent.hasProperty(_contracts_1.Addon.Cover) ? this.parent.getProperty(_contracts_1.Addon.Cover) : undefined;
            await Promise.all([
                this.fetchImage(cover),
                this.fetchVideo(cover),
                this.fetchAuthor(this.parent.get('author')),
                this.fetchGallery(cover)
            ]);
            this.onReady();
        }
        catch (e) {
            this.onError(e);
        }
    }
    /**
     * Checking that content has cover photo - Thumbnail
     */
    get hasThumbnail() {
        return !!this.thumbnail;
    }
    get contentMetadata() {
        dayjs_1.default.extend(utc_1.default);
        dayjs_1.default.extend(timezone_1.default);
        let metaImage = '';
        if (this.image) {
            metaImage = this.image.url;
        }
        if (this.gallery && this.gallery[0]) {
            metaImage = this.gallery[0].url;
        }
        return {
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@type': 'NewsArticle',
                    mainEntityOfPage: {
                        '@type': 'WebPage',
                        '@id': this.headerData.contentProperties.canonicalUrl
                    },
                    headline: this.headerData.meta.title,
                    articleSection: this.headerData.parent ? this.headerData.parent.name : '',
                    description: this.headerData.meta.description,
                    image: metaImage,
                    datePublished: dayjs_1.default.tz(this.headerData.publicationDate, 'Europe/Warsaw').format('YYYY-MM-DDTHH:mm:ssZ'),
                    dateModified: dayjs_1.default.tz(this.headerData.publicationDate, 'Europe/Warsaw').format('YYYY-MM-DDTHH:mm:ssZ'),
                    author: [{
                            '@type': 'Person',
                            name: `${this.resAuthor.firstName} ${this.resAuthor.lastName}`,
                            url: `https://${this.headerData.contentProperties.site.domain}${this.resAuthor.url}`
                        }],
                    inLanguage: this.headerData.contentProperties.site.locale,
                    isAccessibleForFree: !this.headerData.options.hasPaywall,
                    url: this.headerData.contentProperties.canonicalUrl,
                    publisher: {
                        '@id': `https://${this.headerData.contentProperties.site.domain}`,
                        '@type': 'NewsMediaOrganization',
                        name: this.headerData.contentProperties.site.name,
                        logo: this.headerData.contentProperties.site.logo.light
                    }
                }
            ]
        };
    }
    parseLead(markup) {
        let html;
        let obj;
        try {
            obj = this.DeMarked.convertMDToObjects(markup);
            html = this.DeMarked.convertObjectsToHTML(obj);
            this.onReady();
            return html;
        }
        catch (e) {
            this.onError(e);
            return '';
        }
    }
    get isLazy() {
        return this.module.isLazyLoaded;
    }
    get videoAdsTag() {
        return this.headerData.contentProperties.videoAdsTag;
    }
    /**
     * Closes full screen view of image
     */
    closeFullScreenPreview() {
        this.isFullScreenPreviewOpen = false;
    }
    /**
     * Opens image in the full screen mode
     */
    openFullScreenPreview() {
        this.isFullScreenPreviewOpen = true;
    }
    get baseVideoMetadata() {
        let name = this.overridenCaption ? this.overridenCaption : (this.thumbnail ? this.thumbnail.caption : '');
        if (!name) {
            name = this.headerData.meta.title;
        }
        return {
            '@context': 'https://schema.org',
            '@type': 'VideoObject',
            name,
            thumbnailUrl: this.thumbnail ? this.thumbnail.src : '',
            uploadDate: this.headerData.publicationDate
        };
    }
    /**
     * Checking if cover photo has an overriden caption
     */
    get overridenCaption() {
        return (typeof this.headerData.cover === 'object' && this.headerData.cover.override === true) ? this.headerData.cover.caption : undefined;
    }
    /**
     * Get images list to gallery.
     */
    get images() {
        if (!this.gallery) {
            return [];
        }
        return this.gallery;
    }
    get authorLink() {
        if (!this.author || !this.author.url) {
            return '';
        }
        return this.author.url;
    }
    /**
     * TODO: Description.
     */
    get shareButtons() {
        return [
            {
                callback: () => {
                    this.onSocialClick(services_1.ShareType.Facebook);
                },
                icon: 'facebook',
                label: this.$t('share.facebook')
            },
            {
                callback: () => {
                    this.onSocialClick(services_1.ShareType.Twitter);
                },
                icon: 'x',
                label: this.$t('share.twitter')
            },
            {
                callback: () => {
                    this.onSocialClick(services_1.ShareType.LinkedIn);
                },
                icon: 'linkedin',
                label: this.$t('share.linkedin')
            },
            {
                callback: () => {
                    return this.onSocialClick(services_1.ShareType.CopyLink);
                },
                clickedIcon: 'checkmark',
                icon: 'link',
                label: this.$t('share.link')
            },
            {
                callback: () => {
                    this.onSocialClick(services_1.ShareType.Email);
                },
                clickedIcon: 'checkmark',
                icon: 'email',
                label: this.$t('share.email')
            }
        ];
    }
    /**
     * TODO: Description.
     */
    get shareUrl() {
        if (typeof document === 'undefined') {
            return this.headerData.urlPath;
        }
        if (!this.headerData.urlPath) {
            return document.location.origin + document.location.pathname;
        }
        if (this.headerData.urlPath.indexOf('http') >= 0) {
            return this.headerData.urlPath;
        }
        return document.location.origin + '/' + this.headerData.urlPath;
    }
    /**
     * TODO: Description.
     */
    onSocialClick(social) {
        this.shareService.share(social, {
            url: this.shareUrl,
            meta: this.headerData.meta
        });
    }
    /**
     * Article actions.
     */
    get actions() {
        const actions = [
            {
                callback: () => {
                    window.print();
                },
                icon: 'print',
                label: 'Drukuj',
                hideForMobile: true
            }
        ];
        if (this.headerData.pdf && this.pdfService) {
            actions.push({
                callback: () => {
                    if (typeof window !== 'undefined' && this.pdfService && this.headerData.pdf) {
                        const previewMatch = window.location.href.match(/\/preview\/([^/?#]+)/);
                        const previewValue = previewMatch ? previewMatch[1] : null;
                        const pdfData = { ...this.headerData.pdf };
                        if (previewValue) {
                            pdfData.path = `${pdfData.path}?preview=${previewValue}`;
                        }
                        return this.pdfService.downland(pdfData);
                    }
                },
                disabled: !this.headerData.pdf.path,
                icon: 'download',
                label: 'PDF'
            });
        }
        return actions;
    }
    get shouldHideDescription() {
        if (!this.headerData.cover.hideDescription) {
            return false;
        }
        return this.headerData.cover.hideDescription;
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: false,
        default: null
    }),
    __metadata("design:type", Object)
], ArticleTeaserModuleUi.prototype, "pdfService", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], ArticleTeaserModuleUi.prototype, "shareService", void 0);
ArticleTeaserModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'ArticleTeaserModuleUi',
        components: {
            ArticleActions: ui_2.ArticleActions,
            ArticleAuthor: ui_2.ArticleAuthor,
            ArticleHeaderVideo: ArticleHeaderVideo_1.default,
            ArticleShare: ui_2.ArticleShare,
            ArticleSocials: ui_2.ArticleSocials,
            BootstrapButton: bootstrap_1.BootstrapButton,
            BootstrapIcon: bootstrap_1.BootstrapIcon,
            BootstrapImage: bootstrap_1.BootstrapImage,
            BootstrapLink: bootstrap_1.BootstrapLink,
            Gallery: Gallery_1.Gallery,
            ImageWithCaption: ui_2.ImageWithCaption,
            LineHeader: ui_2.LineHeader,
            NoSSR: vue_no_ssr_1.default,
            PlayIcon: ui_2.PlayIcon,
            VueEasyLightbox: vue_easy_lightbox_1.default,
            AdBannerModuleUi: AdBanner_ui_1.AdBannerModuleUi
        },
        mounted() {
            this.watchEvents();
        },
        async created() {
            const parent = this.parent;
            const cover = this.parent.hasProperty(_contracts_1.Addon.Cover) ? this.parent.getProperty(_contracts_1.Addon.Cover) : undefined;
            const videoSettings = this.module.content.videoSettings || {};
            const theme = this.module.content.theme || null;
            const ads = this.module.content.ads || {};
            this.headerData = {
                author: {},
                header: null,
                categoryUrl: parent.get('categoryUrl'),
                ads: ads,
                theme: theme,
                cover: {
                    image: null,
                    video: null,
                    videoSettings,
                    gallery: null,
                    hideDescription: typeof cover === 'object' && cover !== null ? (cover.hideDescription || false) : false
                },
                lead: parent.hasProperty(_contracts_1.Addon.Lead) ? this.parseLead(parent.getProperty(_contracts_1.Addon.Lead)) : null,
                meta: parent.getProperty(_contracts_1.Addon.Meta),
                options: {
                    hasPaywall: parent.get('properties').paywall,
                    hidePublicationDate: this.canHidePublicationDate ? parent.getOption('hidePublicationDate') : false
                },
                contentProperties: {
                    canonicalUrl: parent.get('properties').canonicalUrl,
                    site: parent.get('properties').site,
                    videoAdsTag: parent.get('properties').videoAdsTag
                },
                parent: parent.get('parent'),
                pdf: parent.get('pdf'),
                publicationDate: parent.get('publicationDate'),
                title: parent.get('title'),
                urlPath: parent.get('urlPath')
            };
            this.maxWidth = this.isMobile ? 768 : 800;
            if (this.headerData.theme === _contracts_1.AppTheme.PremiumZone) {
                this.maxWidth = this.isMobile ? 768 : 1220;
            }
            await this.fetchRelated();
        },
        template: `
    <header class="article-header" :class="{ '--loaded': !isLoading }">


    <!-- Theme: PremiumZone -->
    <template v-if="getHeaderData.theme === AppTheme.PremiumZone">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10">
          <!-- Article's parent -->
<!--          <div class="article-header__parent d-flex justify-content-center">-->
<!--            <BootstrapLink v-if="getHeaderData.parent && getHeaderData.parent.name.length"-->
<!--                           :link="{ target: { path: '/'+getHeaderData.categoryUrl } }"-->
<!--                           class="text-decoration-none">-->
<!--              {{ getHeaderData.parent.name }}-->
<!--            </BootstrapLink>-->
<!--          </div>-->

          <!-- Article's title -->
          <h1 class="article-header__title fs-3 fs-lg-1 text-md-center">
            {{ getHeaderData.title }}
          </h1>
        </div>

        <!-- Cover image -->
        <div class="col-12">
          <div class="article-header__image">
            <ImageWithCaption v-if="hasThumbnail" :image="thumbnail" :isLazy="isLazy"
                              :fetchPriority="!isLazy"
                              class="article-header__image__cover --fixed-ratio --21x9">
              <ArticleHeaderVideo v-if="hasVideo"
                                  :video="video"
                                  :videoSettings="getHeaderData.cover.videoSettings"
                                  :videoAdsTag="videoAdsTag"
                                  :noThumbnail="thumbnail === null"
                                  :baseVideoMetadata="baseVideoMetadata"
                                  :eventBus="eventBus"
                                  :siteDomain="getHeaderData.contentProperties.site.address"/>
            </ImageWithCaption>
          </div>
        </div>
        <!-- END | Cover image -->

        <!-- Article's lead -->
        <div v-if="getHeaderData.lead" v-html="getHeaderData.lead" class="col-12 col-md-8 article-header__lead"/>
      </div>

    </template>
    <!-- END | Theme: PremiumZone -->

    <!-- Theme: Default or other sites -->
    <template v-else>
      <template v-if="hasVideo">
        <div class="article-header__wrap">
          <!-- Article's parent -->
<!--          <BootstrapLink v-if="getHeaderData.parent && getHeaderData.parent.name.length"-->
<!--                         :link="{ target: { path: '/' + getHeaderData.categoryUrl } }"-->
<!--                         class="text-decoration-none">-->
<!--            <LineHeader :isBold="true">-->
<!--              {{ getHeaderData.parent.name }}-->
<!--            </LineHeader>-->
<!--          </BootstrapLink>-->
          <!-- END | Article's parent -->
          <!--Cover image / Single image -->
          <div v-if="hasThumbnail || fallbackImage" class="article-header__image">
            <template v-if="hasThumbnail">
              <ImageWithCaption v-if="thumbnail" :image="thumbnail"
                                :hideDescription="true" :isLazy="isLazy"
                                :hideAuthor="true"
                                :fetchPriority="!isLazy"
                                @click="openFullScreenPreview">
                <ArticleHeaderVideo :video="video"
                                    :videoSettings="getHeaderData.cover.videoSettings"
                                    :videoAdsTag="videoAdsTag"
                                    :noThumbnail="thumbnail === null"
                                    :baseVideoMetadata="baseVideoMetadata"
                                    :eventBus="eventBus"
                                    :siteDomain="getHeaderData.contentProperties.site.address"/>
                <AdBannerModuleUi v-if="getHeaderData.ads" class="article-header__ad"
                                  v-bind="{eventBus, fallbackImage, onEmptyCallback: emptyAds, module: getHeaderData.ads, parent, pdfService, shareService, theme, windowService, isMobile, relatedService, forceHide: forceHideAd}"/>

              </ImageWithCaption>
            </template>
            <template v-else>
              <BootstrapImage :src="fallbackImage"/>
              <ArticleHeaderVideo :video="video"
                                  :videoSettings="getHeaderData.cover.videoSettings"
                                  :videoAdsTag="videoAdsTag"
                                  :noThumbnail="thumbnail === null"
                                  :baseVideoMetadata="baseVideoMetadata"
                                  :eventBus="eventBus"
                                  :siteDomain="getHeaderData.contentProperties.site.address"/>
              <AdBannerModuleUi v-if="getHeaderData.ads" class="article-header__ad"
                                v-bind="{eventBus, fallbackImage, onEmptyCallback: emptyAds, module: getHeaderData.ads, parent, pdfService, shareService, theme, windowService, isMobile, relatedService, forceHide: forceHideAd}"/>
            </template>
            <NoSSR>
              <VueEasyLightbox v-if="!hasVideo && thumbnail"
                               :visible="isFullScreenPreviewOpen" :imgs="thumbnail.fullscreen"
                               @hide="closeFullScreenPreview"/>
            </NoSSR>
          </div>
          <!-- END | Cover image -->
          <!-- Title -->
          <h1 class="article-header__title fs-3 fs-lg-1">{{ getHeaderData.title }}</h1>
        </div>
        <div class="row justify-content-between mt-5 mb-4">
          <!-- Author -->
          <div class="col-auto">
            <div v-if="authorLink">
              <BootstrapLink :link="{ target: authorLink }" class="text-decoration-none">
                <ArticleAuthor v-bind="{ publicationDate: getHeaderData.publicationDate }"
                               :hideDate="getHeaderData.options && getHeaderData.options.hidePublicationDate"
                               :name="authorName"
                               :avatar="authorAvatar !== null ? authorAvatar : undefined"
                               :showInitialsWhenNoAvatar="true"/>
              </BootstrapLink>
            </div>
            <div v-else>
              <ArticleAuthor v-bind="{ publicationDate: getHeaderData.publicationDate }"
                             :hideDate="getHeaderData.options && getHeaderData.options.hidePublicationDate"
                             :name="authorName"
                             :avatar="authorAvatar !== null ? authorAvatar : undefined"
                             :showInitialsWhenNoAvatar="true"/>
            </div>
          </div>

          <!-- Print, download & social buttons -->
          <div class="col-auto d-flex justify-content-between align-items-center">
            <ArticleActions class="me-lg-3" v-bind="{ actions }"/>
            <ArticleSocials class="d-none d-lg-block" v-bind="{ enabledServices }"
                            :onClick="onSocialClick"/>
          </div>
        </div>
        <ArticleShare v-bind="{ shareButtons }" :isHidden="false"/>
        <div v-if="getHeaderData.lead" v-html="getHeaderData.lead" class="article-header__lead"/>

      </template>
      <template v-else>
        <!-- Article's parent -->
<!--        <BootstrapLink v-if="getHeaderData.parent && getHeaderData.parent.name.length"-->
<!--                       :link="{ target: { path: '/' + getHeaderData.categoryUrl } }"-->
<!--                       class="text-decoration-none">-->
<!--          <LineHeader :isBold="true">-->
<!--            {{ getHeaderData.parent.name }}-->
<!--          </LineHeader>-->
<!--        </BootstrapLink>-->
        <!-- END | Article's parent -->
        <!-- Title -->
        <h1 class="article-header__title fs-3 fs-lg-1">{{ getHeaderData.title }}</h1>

        <div class="row justify-content-between">
          <!-- Author -->
          <div class="col-auto">
            <div v-if="authorLink">
              <BootstrapLink :link="{ target: authorLink }" class="text-decoration-none">
                <ArticleAuthor v-bind="{ publicationDate: getHeaderData.publicationDate }"
                               :hideDate="getHeaderData.options && getHeaderData.options.hidePublicationDate"
                               :name="authorName"
                               :avatar="authorAvatar !== null ? authorAvatar : undefined"
                               :showInitialsWhenNoAvatar="true"/>
              </BootstrapLink>
            </div>
            <div v-else>
              <ArticleAuthor v-bind="{ publicationDate: getHeaderData.publicationDate }"
                             :hideDate="getHeaderData.options && getHeaderData.options.hidePublicationDate"
                             :name="authorName"
                             :avatar="authorAvatar !== null ? authorAvatar : undefined"
                             :showInitialsWhenNoAvatar="true"/>
            </div>
          </div>

          <!-- Print, download & social buttons -->
          <div class="col-auto d-flex justify-content-between align-items-center">
            <ArticleActions class="me-lg-3" v-bind="{ actions }"/>
            <ArticleSocials class="d-none d-lg-block" v-bind="{ enabledServices }"
                            :onClick="onSocialClick"/>
          </div>
        </div>
        <div class="article-header__wrap">
          <!--Cover image / Gallery -->
          <template v-if="hasGallery">
            <Gallery :images="images" class="article-header__gallery" :maxWidth="maxWidth"
                     :windowService="windowService"
                     fullScreen/>
          </template>
          <!-- END | Cover image / Gallery -->
          <!--Cover image / Single image -->
          <template v-else>
            <div v-if="hasThumbnail || fallbackImage" class="article-header__image">
              <template v-if="hasThumbnail">
                <ImageWithCaption v-if="thumbnail" :image="thumbnail" :overridenCaption="overridenCaption"
                                  :hideDescription="shouldHideDescription" :isLazy="isLazy"
                                  :fetchPriority="!isLazy"
                                  @click="openFullScreenPreview">
                  <AdBannerModuleUi v-if="getHeaderData.ads" class="article-header__ad"
                                    v-bind="{eventBus, fallbackImage, onEmptyCallback: emptyAds, module: getHeaderData.ads, parent, pdfService, shareService, theme, windowService, isMobile, relatedService, forceHide: forceHideAd}"/>

                </ImageWithCaption>
              </template>
              <template v-else>
                <BootstrapImage :src="fallbackImage"/>
                <AdBannerModuleUi v-if="getHeaderData.ads" class="article-header__ad"
                                  v-bind="{eventBus, fallbackImage, onEmptyCallback: emptyAds, module: getHeaderData.ads, parent, pdfService, shareService, theme, windowService, isMobile, relatedService, forceHide: forceHideAd}"/>
              </template>

              <NoSSR>
                <VueEasyLightbox v-if="!hasVideo && thumbnail"
                                 :visible="isFullScreenPreviewOpen" :imgs="thumbnail.fullscreen"
                                 @hide="closeFullScreenPreview"/>
              </NoSSR>
            </div>
          </template>
          <!-- END | Cover image -->
        </div>
        <ArticleShare v-bind="{ shareButtons }" :isHidden="false"/>
        <div v-if="getHeaderData.lead" v-html="getHeaderData.lead" class="article-header__lead"/>
        <div v-else></div>
      </template>
    </template>
    <!-- END | Theme: Default or other sites -->

    <component :is="'script'" type="application/ld+json"
               v-html="JSON.stringify(contentMetadata)"/>
    </header>
  `
    })
], ArticleTeaserModuleUi);
exports.ArticleTeaserModuleUi = ArticleTeaserModuleUi;
//# sourceMappingURL=ArticleTeaser.ui.js.map